import * as signalR from "@microsoft/signalr";
import url from "@/services/Url";
import store from "@/store";
import router from "@/router/index";
import { useToast } from "vue-toastification";
const toast = useToast();
import ToastNotificationTicket from "@/components/custom-toast/ToastNotificationTicket.vue";
import ToastNotificationCustom from "@/components/custom-toast/ToastNotificationCustom.vue";
import $bus from "@/utils/event.js";
import utils from "@/utils/index";
import swal from "@/utils/swalAlert";
import { ref } from "vue";
import axiosInstance from "@/services/Api";
import TokenService from "@/services/TokenService";

const mensagemCarregamento = ref({});

export const hubConnection = {
  connection: null,
  start() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url + "/appHubPath")
      .build();

    setTimeout(() => {
      this.connect();
    }, 100);
  },

  connect() {
    $bus.trigger("exibirLoadingModalGeral", true);
    this.connection.start().then(
      async () => {
        // console.log(
        //   "Conectado ao hub SignalR: " + this.connection.connectionId
        // );

        await this.validarSessaoUsuario();

        this.connection.on("DesconectarSessao", () => {
          //console.log("DesconectarSessao: " + this.connection.connectionId);
          this.logoutSessao();
        });

        this.connection.on("DesconectarConnection", () => {
          //console.log("DesconectarConnection: " + this.connection.connectionId);
          this.logoutConnection();
        });

        this.connection.on("NotificacaoTicket", (id_ticket) => {
          //console.log("NotificacaoTicket: " + id_ticket);
          this.exibirNotificacaoTicket(id_ticket);
        });

        this.connection.on("PagamentoAsaas", (evento) => {
          this.exibirNotificacaoPagamentoAsaas(evento);
        });

        this.connection.on("ReceberAsaas", (evento) => {
          this.exibirNotificacaoReceberAsaas(evento);
        });

        this.connection.on("AtualizacaoPlano", (atualizacaoPlano) => {
          this.exibirNotificacaoAtualizacaoPlano(atualizacaoPlano);
        });

        this.connection.on("CarregamentoDados", (mensagem) => {
          mensagemCarregamento.value = mensagem;
        });

        $bus.trigger("exibirLoadingModalGeral", false);
      },
      () => {
        $bus.trigger("exibirLoadingModalGeral", false);
        setTimeout(() => {
          this.connect();
        }, 60000);
      }
    );

    this.connection.onclose(() => {
      this.connect();
    });
  },

  async validarSessaoUsuario() {
    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));

      if (
        user.TokenExpires !== null &&
        user.TokenExpires !== undefined &&
        new Date(user.TokenExpires) <= new Date()
      ) {
        try {
          const rs = await axiosInstance.post("/v1/auth/refresh-token/", {
            AccessToken: TokenService.getLocalAccessToken(),
            RefreshToken: TokenService.getLocalRefreshToken(),
          });

          if (rs.data.Data.Token) {
            TokenService.setUser(rs.data.Data);
            user = JSON.parse(localStorage.getItem("user"));
          }
        } catch (error) {
          console.log(error);
        }
      }

      try {
        let ret = await this.connection.invoke(
          "ConectarUsuario",
          user.RefreshToken,
          user.User.id
        );
        if (ret.success === true) {
          if (
            router &&
            router.currentRoute &&
            router.currentRoute._value &&
            router.currentRoute._value.name &&
            router.currentRoute._value.name.includes("sign-in")
          ) {
            router.push("/" + utils.getWL() + "/dashboard");
          }
        } else {
          if (
            !(
              router &&
              router.currentRoute &&
              router.currentRoute._value &&
              router.currentRoute._value.name &&
              (router.currentRoute._value.name.includes("sign-in") ||
                router.currentRoute._value.name.includes("404"))
            )
          ) {
            await swal.showInvalidAlert(ret.message, (alert) => {
              this.logoutConnection();
            });
          }
        }
      } catch (error) {
        await swal.showErrorAlert(error.message, (alert) => {
          this.logoutConnection();
        });
      }
    } else {
      if (
        !(
          router &&
          router.currentRoute &&
          router.currentRoute._value &&
          router.currentRoute._value.name &&
          (router.currentRoute._value.name.includes("register") ||
            router.currentRoute._value.name.includes("password-reset"))
        )
      ) {
        router.push("/" + utils.getWL() + "/sign-in");
      }
    }
  },

  logoutSessao() {
    store.dispatch("auth/logout").then(() => {
      router.push("/" + utils.getWL() + "/sign-in");
      toast.info("Sessão expirada, por favor faça login novamente!", {
        timeout: 3000,
      });
    });
  },

  logoutConnection() {
    router.push("/" + utils.getWL() + "/sign-in");
    toast.info("Sessão expirada, por favor faça login novamente!", {
      timeout: 3000,
    });
  },

  exibirNotificacaoTicket(id_ticket) {
    toast.info(
      {
        component: ToastNotificationTicket,
        listeners: {
          abrirTicket: () => {
            if (
              router &&
              router.currentRoute &&
              router.currentRoute._value &&
              router.currentRoute._value.path &&
              router.currentRoute._value.path.includes(
                "/suporte/ticket/editar/" + id_ticket.toString()
              )
            ) {
              $bus.trigger("atualizar-ticket");
            } else {
              router.push(
                "/" +
                  utils.getWL() +
                  "/suporte/ticket/editar/" +
                  id_ticket.toString()
              );
            }
          },
        },
      },
      {
        timeout: false,
      }
    );
  },

  exibirNotificacaoPagamentoAsaas(evento) {
    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));
      let rota = "";
      if (
        user.User.TipoUsuario.tipo === "Administrador" ||
        user.User.TipoUsuario.tipo === "Distribuidor Master" ||
        user.User.TipoUsuario.tipo === "Distribuidor" ||
        user.User.TipoUsuario.tipo === "Revenda"
      ) {
        rota = "/principal/licencarecebivel/consultar";
      } else {
        rota = "/fatura/licenca/consultar";
      }
      let mensagem = `Cobrança Asaas: ${
        evento === "PAYMENT_CONFIRMED"
          ? "Pagamento confirmado"
          : evento === "PAYMENT_RECEIVED"
          ? "Pagamento recebido"
          : evento
      }`;
      if (
        router &&
        router.currentRoute &&
        router.currentRoute._value &&
        router.currentRoute._value.path &&
        router.currentRoute._value.path.includes(rota)
      ) {
        toast.info(mensagem, {
          timeout: 3000,
        });
        $bus.trigger("atualizar-pagamentos-asaas");
      } else {
        toast.info(
          {
            component: ToastNotificationCustom,
            props: {
              mensagem: mensagem,
            },
            listeners: {
              abrirMensagem: () => {
                router.push("/" + utils.getWL() + rota);
              },
            },
          },
          {
            timeout: false,
          }
        );
      }
    }
  },

  exibirNotificacaoReceberAsaas(evento) {
    let mensagem = `Cobrança Asaas: ${
      evento === "PAYMENT_CONFIRMED"
        ? "Pagamento confirmado"
        : evento === "PAYMENT_RECEIVED"
        ? "Pagamento recebido"
        : evento
    }`;
    if (
      router &&
      router.currentRoute &&
      router.currentRoute._value &&
      router.currentRoute._value.path &&
      router.currentRoute._value.path.includes("/financeiro/receber/consultar")
    ) {
      toast.info(mensagem, {
        timeout: 3000,
      });
      $bus.trigger("atualizar-receber-asaas");
    } else {
      toast.info(
        {
          component: ToastNotificationCustom,
          props: {
            mensagem: mensagem,
          },
          listeners: {
            abrirMensagem: () => {
              router.push(
                "/" + utils.getWL() + "/financeiro/receber/consultar"
              );
            },
          },
        },
        {
          timeout: false,
        }
      );
    }
  },

  async exibirNotificacaoAtualizacaoPlano(atualizacaoPlano) {
    let mensagem = `Parabéns você acaba de obter acesso ao plano: ${
      utils.retornarPlano(atualizacaoPlano.tipo_pacote_solicitado).titulo
    } da ${utils.getNomeEmpresaWL()}! Faça login novamente para aproveitar os novos recursos disponíveis!`;
    await swal.showInfoAlert(mensagem, (alert) => {
      this.logoutSessao();
    });
  },
};

export { mensagemCarregamento };
export default hubConnection;
